export default __webpack_public_path__ + "static/media/Tom Hegna.b6355f2f.jpg";